import axios from 'axios';
//线上环境
const url = 'https://api.betopfun.com/web.php?';
//测试环境
//const url = 'http://api.lan.betophall.com/web.php?';
//测试
//const url = 'https://alpha.api.betopfun.com/web.php?';

const options = {
//	act:'faqIndex',
	ts:'1458023485647',
	appid:'1003',
	nettype:'1',
	sign:'47971c1cfb2377f91ef4d1ac664819b6',
	debug:'1'
}

//ajax get方法
export function get(parameter) {
	const data = Object.assign(parameter, options);
	
	return axios.get(url, {
		params: data
	}).then((res) => {
		return Promise.resolve(res.data)
		
	}).catch(function (res) {
		return Promise.resolve(res);	
	});
}

//判断是否PC
export function isPC(){
    /**
     * 判断是否为pc
     */
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone",
                "SymbianOS", "Windows Phone",
                "iPad", "iPod"];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}



// WEBPACK FOOTER //
// ./src/assets/api/config.js